import { useSitecoreContext } from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import { ComponentProps } from "@repo/sitecore-lib/component-props";
import * as Flex from "@repo/ui/flex";
import Placeholder from "../placeholder-component/placeholder";
import styles from "./container-component.module.css";

type ContainerComponentProps = ComponentProps & {
  classname?: string;
};

const ContainerComponent = (props: ContainerComponentProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  const placeholders = props.rendering.placeholders;

  return (
    <Flex.Container
      column
      justify="start"
      className={clsx(styles.containerComponent, styles[props.classname!])}
      align={!isEditing ? "start" : undefined}
    >
      {placeholders &&
        Object.entries(placeholders).map(([key]) => {
          return (
            <Placeholder
              key={key}
              name={key}
              rendering={props.rendering}
              classname={props.classname}
            />
          );
        })}
    </Flex.Container>
  );
};

export default ContainerComponent;
